import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=a90bae98&scoped=true&"
import script from "./Team.vue?vue&type=script&setup=true&lang=js&"
export * from "./Team.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90bae98",
  null
  
)

export default component.exports